import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import { signIn } from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class Login extends Component {
  state = {
    menuToggled: false,
    email: "",
    password: "",
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  componentDidMount() {}

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };
  handleSubmit = (e) => {
    //console.log(this.state);
    this.authError = "";
    e.preventDefault();
    this.props.signIn(this.state);
  };

  render() {
    const { vai, auth, authError } = this.props;
    if (auth.uid || vai) return <Redirect to="/" />;
    return (
      <div>
        <Helmet>
          <title>Connexion</title>
          <meta
            name="description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/login" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Log in:
              </h2>
              <form onSubmit={this.handleSubmit}>
                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="email"
                    placeholder="Entrez votre email"
                    id="email"
                    required
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="password"
                    placeholder="Entrz votre mot de passe"
                    id="password"
                    onChange={this.handleChange}
                    required
                  />
                </div>

                <div style={{ height: "20px" }}></div>

                <button
                  disabled={this.props.loading}
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  /* onClick={() => {
                  this.setState({ finished: false });
                }}*/
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  Log in
                </button>

                <div style={{ height: "20px" }}></div>

                {authError && !this.props.loading ? (
                  <div
                    style={{
                      color: "#EE1D52",
                      fontSize: "18px",
                      marginBottom: "20px",
                    }}
                  >
                    {authError}
                  </div>
                ) : null}
              </form>
              <span
                style={{
                  fontSize: "18px",
                  color: "#fff",
                  borderRadius: "2px",
                }}
              >
                <Link style={{ color: "white" }} to="/recovery">
                  Vous avez oublié votre mot de passe?
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    loading: state.auth.loading,
    vai: state.auth.vai,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
